import Vue from 'vue';

export default {
	async fetch(details) {
		const response = await Vue.axios.get('/products', {
			headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
		});

		return response.data;
	},
};
